// axios
import request from '@/utils/request';

const api = {
  login: '/webApi/login',
  updateUserInfo: '/webApi/userInfo/updateUserInfo',
  getUserInfo: '/webApi/userInfo/getUserInfo',
  logout: '/webApi/logout',
  ssoLogout: 'https://hep-center.u2.hep.com.cn/logout' /* sso退出登录 */,
  specialList: '/webApi/special/specialList',
  specailSearch: '/webApi/special/tSpecialSubjectSearchList',
  adList: '/webApi/ad/adList',
  userLike: '/webApi/special/userLike',
  defaultSearchText: '/webApi/platformConfig/getPlatformSearchKey',
  fpglOpen: '/webApi/invoice/fpglOpen',
  appConfig: '/business/websiteConfig/getConfig',
  adClick:`/business/adInfo/click`,
  getWebSiteFootDto:`/webApi/platformConfig/getWebSiteFootDto`,
  getIsOpenExchangeCode:`/website/websiteConfig/getIsOpenExchangeCode`
};


export function indexSpecialList(params) {
  return request({
    url: api.specailSearch,
    method: 'get',
    params,
  });
}

// 登录
export function specialList(data) {
  return request({
    url: api.specialList,
    method: 'get',
    data,
  });
}

export function baseLoad(config) {
  return request(config);
}

export function download(url, fileName) {
  const fileExt = url.split('.').reverse()[0];
  var a = document.createElement('a');
  a.download = `${fileName}.${fileExt}`;
  a.href = url;
  document.getElementsByTagName('body')[0].append(a);
  a.click();
  a.remove();
}

// 登录
export function specialSearch(data) {
  return request({
    url: api.specialSearch,
    method: 'get',
    data,
  });
}

export function userLike(params) {
  return request({
    url: api.userLike,
    method: 'get',
    params,
  });
}

// 广告列表
export function adList(params) {
  return request({
    url: api.adList,
    method: 'get',
    params,
  });
}

// 用户信息 post 方法
export function getUserInfo(data) {
  return request({
    url: api.UserInfo,
    method: 'post',
    data,
    hideloading: true,
  });
}

// 用户名称 get 方法
export function getUserName(params) {
  return request({
    url: api.UserName,
    method: 'get',
    params,
    hideloading: true,
  });
}

// 默认搜索词
export function defaultSearchText(params) {
  return request({
    url: api.defaultSearchText,
    method: 'get',
    params,
    hideloading: true,
  });
}

// 是否可申请开票
export function fpglOpen(params) {
  return request({
    url: api.fpglOpen,
    method: 'get',
    params,
    hideloading: true,
  });
}

// 应用配置
export function getAppConfig(params) {
  return request({
    url: api.appConfig,
    method: 'get',
    params,
    hideloading: true,
  });
}

// 广告点击
export function adClick(id) {
  return request({
    url: `${api.adClick}?tAdId=${id}`,
    method: 'get',
    hideloading: true,
  });
}

// 喜欢显示隐藏
export function getWebSiteFootDtoApi(params) {
  return request({
    url: `${api.getWebSiteFootDto}`,
    method: 'get',
    params,
  });
}

// 获取教材兑换开关
export function getIsOpenExchangeCode(params) {
  return request({
    url: `${api.getIsOpenExchangeCode}`,
    method: 'get',
    params,
  });
}